import Swiper from 'swiper/bundle';

export default class Sliders {
    constructor() {
        
        this.init();
        this.initNavContactSwiper();
        this.initClientsSwiper();
        this.initProductSwiper();
        this.initProductCatSwiper();

    }

    init() {

    }

    // === SWIPER NAV-CONTACT ===
    initNavContactSwiper() {
        const navContactSwiper = new Swiper(".swiper-navContact", {
            spaceBetween: 30,
            centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 3500,
                disableOnInteraction: false,
            },
        });
    }

    // === SWIPER CLIENTS ===
    initClientsSwiper() {
        const swiperClientsContainer = document.querySelector('.swiper-clients .swiper-wrapper');
        if( swiperClientsContainer ) {
            let swiperClientsSlides = document.querySelectorAll('.swiper-clients .swiper-slide');
            const totalNeededSlides = 7;
            const duplicationFactor = Math.ceil(totalNeededSlides / swiperClientsSlides.length);

            for( let i = 0; i < duplicationFactor; i++ ) {
                swiperClientsSlides.forEach(slide => {
                    const clonedSlide = slide.cloneNode(true);
                    swiperClientsContainer.appendChild(clonedSlide);
                });
            }

            // while (swiperClientsSlides.length < totalNeededSlides) {
            //     swiperClientsSlides.forEach(slide => {
            //         const clonedSlide = slide.cloneNode(true);
            //         swiperClientsContainer.appendChild(clonedSlide);
            //     });
            //     swiperClientsSlides = document.querySelectorAll('.swiper-clients .swiper-slide');
            // }

            const clientsLogosSwiper = new Swiper(".swiper-clients", {
                slidesPerView: 2,
                spaceBetween: 16,
                loop: true,
                autoplay: {
                    delay: 3500,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 16,
                    },
                    1200: {
                        slidesPerView: 6,
                        spaceBetween: 16,
                    },
                },
            });
        }
    }

    // === PRODUCT SWIPER ===
    initProductSwiper() {
        const productSwiper = new Swiper(".product-swiper", {
            effect: "cards",
            grabCursor: true,
            navigation: {
                nextEl: ".product-swiper .swiper-next",
                prevEl: ".product-swiper .swiper-prev",
            },
        });
    }

    // === PRODUCT CAT SWIPER ===
    initProductCatSwiper() {
        let swiperProductCatTitle = new Swiper(".swiper-product-cat-title", {
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
        });
        let swiperProductCatThumb = new Swiper(".swiper-product-cat-thumb", {
            spaceBetween: 0,
            effect: "creative",
            creativeEffect: {
                prev: {
                    shadow: true,
                    translate: ["-20%", 0, -1],
                },
                next: {
                    translate: ["100%", 0, 0],
                },
            },
            navigation: {
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev",
            },
            thumbs: {
                swiper: swiperProductCatTitle,
            },
        });
    }

}